import { Helpers } from '../../helpers';
import { IItemSubCategory } from '../../interfaces/iitem-sub-category';
import { Item } from '../item';
import { ItemCategory } from '../item-category';
import { ItemRate } from '../item-rate';
import { ProjectResourceItemsRevision } from '../project-resource-items-revision';

export class ItemSubCategoryBase {
  ItemSubCategoryId: number;
  ItemCategoryId: number | null;
  ItemSubCategoryName: string;
  SortOrder: number | null;
  Source: string | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ItemRates_ItemSubCategory?: Array<ItemRate> | null;
  Items_ItemSubCategory?: Array<Item> | null;
  ProjectResourceItemsRevisions_ScheduleActivity?: Array<ProjectResourceItemsRevision> | null;
  ItemCategory?: ItemCategory;

  constructor(item?: IItemSubCategory) {
    if (item) {

      this.ItemSubCategoryId = item.ItemSubCategoryId;
      this.ItemCategoryId = item.ItemCategoryId;
      this.ItemSubCategoryName = item.ItemSubCategoryName;
      this.SortOrder = item.SortOrder;
      this.Source = item.Source;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ItemRates_ItemSubCategory = Helpers.createClassArray(ItemRate, item.ItemRates_ItemSubCategory);
      this.Items_ItemSubCategory = Helpers.createClassArray(Item, item.Items_ItemSubCategory);
      this.ProjectResourceItemsRevisions_ScheduleActivity = Helpers.createClassArray(ProjectResourceItemsRevision, item.ProjectResourceItemsRevisions_ScheduleActivity);
      this.ItemCategory = new ItemCategory(item.ItemCategory);
    }
  }
}